import { default as AxiosIns } from "axios";
import Cookies from "js-cookie";
import { getStore } from "app/configureStore";
import { getPfsParams } from "app/features/pfsParams/pfsParamsSelectors";
import { isTargetApiUrl } from "app/utils/utils.url";

const axios = AxiosIns.create();

axios.interceptors.request.use(
	config => {
		const shop = window?.location?.pathname?.split("/")[1];
		const token = Cookies.get("authToken", { path: `/${shop}` });

		const authorization = config?.headers?.Authorization;

		if (token && !authorization) {
			config.headers.Authorization = token;
		}

		// Ajouter les paramètres pfs- aux headers pour les API ciblées
		if (isTargetApiUrl(config.url)) {
			const store = getStore();
			const state = store.getState();
			const pfsParams = getPfsParams(state);

			if (pfsParams && Object.keys(pfsParams).length > 0) {
				// Ajouter chaque paramètre pfs- comme header
				Object.entries(pfsParams).forEach(([key, value]) => {
					config.headers[key] = value;
				});
			}
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

export default axios;
